import React, { PropsWithChildren } from 'react';
import SignpostContent, { SignpostContentProps } from '../SignpostContent';

type SignpostContentWrapperProps = { signpostContent: SignpostContentProps | undefined };

const SignpostContentWrapper: React.FC<
  PropsWithChildren<SignpostContentWrapperProps>
> = ({ signpostContent, children }) => {
  return !signpostContent ? <>{children}</> : <SignpostContent {...signpostContent} />;
};

export default SignpostContentWrapper;
